import { OrgModel } from './org.model'; // Assuming OrgModel exists for organisation details

export interface UserOrgPermission {
  id: number;
  permission: {
    id: number;
    name: string;
    displayName: string;
  };
  organisation?: {
    id: string;
    legalName: string;
    displayName: string;
  };
}

/* TODO: this needs implemented across the code, we use normal strings elsewhere */
export enum ConsentType {
  DATA = "DATA",
  MARKETING = "MARKETING",
  ANALYTICS = "ANALYTICS"
}

export interface UserModel {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  firebaseUID: string;
  consent?: {
    consentString: string;
    dateTimeUTC: Date;
    status: boolean;
    type: ConsentType;
  }[];
  createdAt: Date;
  updatedAt: Date;
  userOrgPermissions: UserOrgPermission[];
}

export interface CreateUserModel extends Omit<UserModel, 'id' | 'createdAt' | 'updatedAt' | 'firebaseUID' | 'userOrgPermissions'> {
  password?: string; // Add password field for creation
}

export interface UpdateUserModel extends Partial<Omit<UserModel, 'id' | 'email' | 'firebaseUID' | 'createdAt' | 'updatedAt' | 'userOrgPermissions'>> {}
